var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedValueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 72,
    viewBox: "0 0 130 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M41.7838 42.0132L41.5912 40.7944L41.7838 42.0132ZM70.3243 8.74595L70.6043 9.94767L70.3243 8.74595ZM130 8.74599L118.47 0.375206L116.986 14.5456L130 8.74599ZM3.22128 71.6761C4.46175 63.071 9.06855 56.7953 15.8904 52.242C22.7505 47.6631 31.8509 44.832 41.9764 43.2319L41.5912 40.7944C31.2907 42.4221 21.7969 45.3326 14.5204 50.1894C7.20569 55.0716 2.13358 61.9254 0.77872 71.3239L3.22128 71.6761ZM41.9764 43.2319C46.178 42.568 49.1919 40.1588 51.5521 37.0303C53.8862 33.9365 55.6524 30.0419 57.3405 26.2728C59.055 22.4448 60.6912 18.7409 62.7897 15.7666C64.8688 12.8196 67.3178 10.7134 70.6043 9.94767L70.0443 7.54424C65.9646 8.49481 63.0579 11.1057 60.7733 14.3439C58.5079 17.5547 56.7723 21.5038 55.0882 25.2641C53.3777 29.0832 51.7186 32.712 49.5821 35.5441C47.4716 38.3415 44.9695 40.2605 41.5912 40.7944L41.9764 43.2319ZM70.6043 9.94767C84.7019 6.66295 105.928 7.70595 118.849 8.81823L119.06 6.35951C106.166 5.24947 84.5719 4.15933 70.0443 7.54424L70.6043 9.94767Z",
    fill: "url(#paint0_linear_3_12339)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_12339",
    x1: 119.805,
    y1: 4.5,
    x2: 96.9656,
    y2: 84.2107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480335,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedValueArrow);
export default __webpack_public_path__ + "static/media/locked_value_arrow.229a1f6d093460243a9267efaab6ae5a.svg";
export { ForwardRef as ReactComponent };